import React from 'react';
import { featureCategories, onboardingFee, plans } from '../../data/pricing';
import { FeatureCell } from './FeatureCell';
const labelCell = 'sticky left-0 z-10 border-b border-gray-200 px-6 text-left align-middle';
const valueCell = 'border-b border-l border-gray-200 px-4 text-center align-middle';
export function PricingTable() {
  return <section aria-labelledby="compare-plans" className="bg-white px-4 pb-16 pt-20 sm:px-6 lg:px-8" data-id="element-646" data-mp="2yvdqdvsms6sr">
      <h2 id="compare-plans" className="sr-only" data-id="element-647" data-mp="32ve57hjn6k0c">
        Compare plans
      </h2>
      <div className="mx-auto max-w-[1440px] overflow-x-auto border border-gray-200 shadow-sm" data-id="element-648" data-mp="37tfw2onb7nmd">
        <table className="w-full min-w-[980px] table-fixed border-collapse" data-id="element-649" data-mp="3cms901imm5za">
          <colgroup data-id="element-650" data-mp="3hktt8prsgbcc">
            <col className="w-[28%]" data-id="element-651" data-mp="3hj9116sy54hn" />
            {plans.map(plan => <col key={plan.id} className="w-[18%]" data-id="element-652" data-mp="3mkg813n9lzn9" />)}
          </colgroup>

          <thead data-id="element-653" data-mp="3qkqnd6wy62es">
            <tr data-id="element-654" data-mp="3qma2uvas49fi">
              <th scope="col" className={`${labelCell} bg-white px-8 py-10 font-normal`} data-id="element-655" data-mp="3qlrwh5ueketv">
                <p className="text-xl italic leading-snug text-gray-800 lg:text-2xl" data-id="element-656" data-mp="2dvmqfbhi7r6s">
                  Choose a plan that's right
                  <br data-id="element-657" data-mp="28y4nq2u2y878" />
                  for your business.
                </p>
                <p className="mt-6 text-sm leading-relaxed text-gray-600" data-id="element-658" data-mp="23wxgq5zrhd1m">
                  Prices shown are card price. Paying by ACH or check? Email{' '}
                  <a href="mailto:Results@GetAdROI.com" className="font-medium text-brand-red underline-offset-2 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-red" data-id="element-659" data-mp="2wlm8heexg60p">
                    Results@GetAdROI.com
                  </a>{' '}
                  for details.
                </p>
                <p className="mt-4 text-sm font-semibold text-gray-900" data-id="element-660" data-mp="3fbu99pv5mkdq">3-month minimum term.</p>
              </th>
              {plans.map(plan => <th key={plan.id} scope="col" className={`${plan.headerClass} px-4 py-10 text-center align-middle font-normal`} data-id="element-661" data-mp="3ajkmgipc60fo">
                  {plan.popular && <span className="mb-3 inline-block rounded-full bg-white px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-brand-red" data-id="element-662" data-mp="1dmy42mxrvpj6">
                      Most popular
                    </span>}
                  <p className={`text-xs font-semibold uppercase tracking-[0.18em] ${plan.subtleText}`} data-id="element-663" data-mp="13vahp0g2oyok">{plan.tier}</p>
                  <p className="mt-2 text-lg font-extrabold uppercase tracking-tight" data-id="element-664" data-mp="pz6s5kg59eif">{plan.name}</p>
                  <p className="mt-5 text-4xl font-black tracking-tight xl:text-5xl" data-id="element-665" data-mp="twl078s39g8u">{plan.price}</p>
                  <p className={`mt-1 text-sm ${plan.subtleText}`} data-id="element-666" data-mp="g193ivudhfpa">per month</p>
                </th>)}
            </tr>
          </thead>

          <tbody data-id="element-667" data-mp="2adyxfdkqqowo">
            <tr data-id="element-668" data-mp="2adgtrvvr18eq">
              <th scope="row" className={`${labelCell} bg-gray-50 py-5 text-xs font-bold uppercase tracking-[0.14em] text-brand-gray`} data-id="element-669" data-mp="2aaumlxcrsux1">
                What each plan is for
              </th>
              {plans.map(plan => <td key={plan.id} className={`${valueCell} bg-gray-50 py-5 text-sm leading-relaxed text-gray-600`} data-id="element-670" data-mp="3uv86b3x1nwhp">
                  {plan.purpose}
                </td>)}
            </tr>
            <tr data-id="element-671" data-mp="8o1h666cf7ke">
              <th scope="row" className={`${labelCell} bg-white py-5`} data-id="element-672" data-mp="8nhwwit80737">
                <span className="block font-bold text-gray-900" data-id="element-673" data-mp="mewimxeiimdy">White Glove Onboarding, One-Time</span>
                <span className="mt-1 block text-sm font-normal text-gray-500" data-id="element-674" data-mp="hgbs5pp2bh2p">
                  Includes a real website build during onboarding.
                </span>
              </th>
              {plans.map(plan => <td key={plan.id} className={`${valueCell} py-5 text-lg font-bold text-gray-900`} data-id="element-675" data-mp="rfaruiruo2dk">
                  {onboardingFee}
                </td>)}
            </tr>

            {featureCategories.map(category => <React.Fragment key={category.title} data-id="element-676" data-mp="2t7p8zfmkl2sx">
                <tr data-id="element-677" data-mp="1k9gzdqdspp52">
                  <th scope="colgroup" className="sticky left-0 z-10 bg-brand-red px-6 py-3 text-left text-sm font-extrabold uppercase tracking-wide text-white" data-id="element-678" data-mp="1k85x5v000pg2">
                    {category.title}
                  </th>
                  {plans.map(plan => <td key={plan.id} className={`${plan.bandClass} px-4 py-2 text-center`} aria-hidden="true" data-id="element-679" data-mp="1y6clokj25d32">
                      <span className="block text-[11px] font-bold uppercase tracking-[0.14em]" data-id="element-680" data-mp="11gd6i78ejgbi">{plan.name}</span>
                      <span className="text-sm font-extrabold" data-id="element-681" data-mp="1aj4h64tge823">
                        {plan.price}
                        <span className={`text-xs font-medium ${plan.subtleText}`} data-id="element-682" data-mp="1f9cku5wg74hh">/mo</span>
                      </span>
                    </td>)}
                </tr>
                {category.features.map(feature => <tr key={feature.name} data-id="element-683" data-mp="mrz0xojlpdr9">
                    <th scope="row" className={`${labelCell} bg-white py-3 text-sm font-medium text-gray-800`} data-id="element-684" data-mp="f9sig38f3hi4">
                      {feature.name}
                    </th>
                    {plans.map(plan => <td key={plan.id} className={`${valueCell} py-3`} data-id="element-685" data-mp="68kx0lr02b5g">
                        <FeatureCell value={feature.values[plan.id]} data-id="element-686" data-mp="6axaalltbxc6" />
                      </td>)}
                  </tr>)}
                {category.footnote && <tr data-id="element-687" data-mp="3npkmmolnhv5q">
                    <td colSpan={plans.length + 1} className="border-b border-gray-200 bg-gray-50 px-6 py-3 text-xs leading-relaxed text-gray-600" data-id="element-688" data-mp="3np2g8z59y0k3">
                      {category.footnote}
                    </td>
                  </tr>}
              </React.Fragment>)}

            <tr data-id="element-689" data-mp="39qcidhamrwuo">
              <th scope="row" className="sticky left-0 z-10 bg-white px-6 py-6 text-left" data-id="element-690" data-mp="39orqy0jm4u11">
                <span className="sr-only" data-id="element-691" data-mp="34qgfxmhl0dh8">Choose a plan</span>
              </th>
              {plans.map(plan => <td key={plan.id} className="px-4 py-6 text-center" data-id="element-692" data-mp="2v2b7fzgs62a2">
                  <a href="mailto:Results@GetAdROI.com" className={`inline-flex w-full items-center justify-center rounded-md px-4 py-3 text-sm font-bold transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-red focus-visible:ring-offset-2 ${plan.buttonClass}`} data-id="element-693" data-mp="302qk0ot8n5qz">
                    Get Started
                  </a>
                </td>)}
            </tr>
          </tbody>
        </table>
      </div>

      <div className="mx-auto mt-10 max-w-2xl text-center text-sm leading-relaxed text-gray-600" data-id="element-694" data-mp="3430xemjd0yfv">
        <a href="#/pricing/additional-costs" className="mb-8 inline-flex items-center justify-center rounded-md border-2 border-brand-black bg-white px-6 py-3 text-sm font-bold text-brand-black transition-colors duration-150 ease-out hover:bg-brand-black hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-red focus-visible:ring-offset-2" data-id="element-695" data-mp="391kkwrdlqiac">
          See Every Additional Cost
        </a>
        <p data-id="element-696" data-mp="1zu0uawadzgm2">
          All plans include White Glove Onboarding ({onboardingFee}, one-time) with a real website build. 3-month minimum
          term.
        </p>
        <p className="mt-2" data-id="element-697" data-mp="1uvfrqq7nwkug">Upgrade or add services at any time.</p>
        <a href="tel:17022134801" className="mt-4 inline-block font-semibold text-brand-red underline-offset-2 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-red" data-id="element-698" data-mp="174juhdkfsxft">
          Not sure which plan fits? Book a free strategy call →
        </a>
      </div>
    </section>;
}